<template>
  <div>
    <kst-output print-mode field="ReductionNumber" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="Date" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../StockReductionCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>